export default __webpack_public_path__ + "static/floating-banks-99197bbbc49ca799795bb1aef93829b6.png";